// ============================================================
// Toast — Ephemeral notification
// Slides up, stays visible, then slides out
// ============================================================

import { useEffect, useState } from "react"
import styles from "./Toast.module.css"

interface ToastProps {
  message: string
  /** Duration in ms before the toast dismisses (default 2500) */
  duration?: number
  /** Called when the toast finishes its exit animation */
  onDone: () => void
}

export const Toast = ({ message, duration = 2500, onDone }: ToastProps) => {
  const [exiting, setExiting] = useState(false)

  useEffect(() => {
    const stayTimer = setTimeout(() => {
      setExiting(true)
    }, duration)

    const doneTimer = setTimeout(() => {
      onDone()
    }, duration + 200) // 200ms exit animation

    return () => {
      clearTimeout(stayTimer)
      clearTimeout(doneTimer)
    }
  }, [duration, onDone])

  return (
    <div
      className={`${styles.toast} ${exiting ? styles.toastExit : ""}`}
      role="status"
      aria-live="polite"
    >
      {message}
    </div>
  )
}
